/**
 * Extract a markdown / text body from an artifact's content.
 *
 * Backend-emitted typed artifacts (decision_log, pulse_digest,
 * handoff_note, project_manifest, document) wrap their rich body in a
 * jsonb object keyed by `markdown` — sometimes `text` or `body` for
 * other resolvers. Without this extractor, viewers that only check
 * `typeof content === 'string'` fall through to JSON.stringify and the
 * page displays the raw envelope instead of the rendered markdown.
 *
 * Returns the first non-empty string body found among the recognized
 * keys, in priority order. Returns null if nothing matches — caller
 * should fall back to JSON.stringify or another viewer.
 */
export function extractMarkdownBody(content: unknown): string | null {
  if (typeof content === 'string') {
    return content.trim().length > 0 ? content : null;
  }
  if (!content || typeof content !== 'object') return null;
  const obj = content as Record<string, unknown>;
  for (const key of ['markdown', 'text', 'body', 'content']) {
    const value = obj[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }
  return null;
}
